import { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import clsx from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";

var JoveSliderTabs = function JoveSliderTabs(props) {
  var _props$type = props.type,
      type = _props$type === void 0 ? 'cross' : _props$type,
      className = props.className,
      list = props.list,
      value = props.value,
      valueChange = props.valueChange,
      width = props.width,
      height = props.height,
      _props$direction = props.direction,
      direction = _props$direction === void 0 ? 'row' : _props$direction;

  var _useState = useState(list || []),
      tabList = _useState[0],
      setTabList = _useState[1];

  var _useState2 = useState(''),
      selectTab = _useState2[0],
      setSelectTab = _useState2[1];
  /**
   * effects
   */


  useEffect(function () {
    setSelectTab(value);
  }, [value]);
  /**
   * methods
   */

  var selectTabAction = function selectTabAction(item) {
    valueChange === null || valueChange === void 0 ? void 0 : valueChange(item.value);
  };

  return /*#__PURE__*/_jsx(Box, {
    className: clsx('flex', direction === 'row' ? 'flex-row justify-center space-x-2' : 'flex-col justify-center space-y-2', className),
    children: tabList.map(function (item, index) {
      return /*#__PURE__*/_jsx(Box, {
        className: clsx('cursor-pointer rounded-full', type === 'circle' ? "w-[".concat(width, "] h-[").concat(width, "]") : "h-full w-12", selectTab === item.value ? 'bg-[#0E35D1]' : 'bg-[#D6D6D6]'),
        onClick: function onClick() {
          return selectTabAction(item);
        }
      }, index);
    })
  });
};

export default JoveSliderTabs;